import { useState } from 'react';
import Image from 'global/Image';
import { CollapsibleItem } from './constants';
import {
  AccordionItemContainer,
  AccordionItemWrapper,
  AccordionWrapper,
} from './styled';

interface IProps {
  content: CollapsibleItem[];
}

const AccordionItem = ({ title, content }: CollapsibleItem) => {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <AccordionItemWrapper onClick={() => setOpen(!open)} active={open}>
      <AccordionItemContainer active={open} onClick={() => setOpen(!open)}>
        <div className="collapsible">{title}</div>
        <div className={`content ${open ? 'active' : 'inactive'}`}>
          {content}
        </div>
      </AccordionItemContainer>
      <Image
        className="chevron"
        src="icon/chevron-down.svg"
        width="32"
        height="32"
      />
    </AccordionItemWrapper>
  );
};

const Accordion = ({ content }: IProps) => (
  <AccordionWrapper>
    {content.map((item, index) => (
      <div key={`accordion-${index + 1}`}>
        <AccordionItem title={item.title} content={item.content} />
      </div>
    ))}
  </AccordionWrapper>
);

export default Accordion;
